<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i class="fal fa-user"></i><b-badge pill variant="success">{{itemsCount}}</b-badge>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="dropdown-menu-lg text-center"><strong>You have {{itemsCount}} notifications</strong></b-dropdown-header>
      <b-dropdown-item><i class="icon-user-follow text-success"></i> New user registered</b-dropdown-item>
      <b-dropdown-item><i class="icon-user-unfollow text-danger"></i> User deleted</b-dropdown-item>
      <b-dropdown-item><i class="icon-chart text-info"></i> Sales report is ready</b-dropdown-item>
      <b-dropdown-item><i class="icon-basket-loaded text-primary"></i> New client</b-dropdown-item>
      <b-dropdown-item><i class="icon-speedometer text-warning"></i> Server overloaded</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownNotif',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 5 }
  }
}
</script>
